<template>
    <div class="worklist">
        <div style="position: fixed; z-index: 99; top: 0px; left: 0px; width: 100%;">
            <el-row style="background-color: #00BAFF; color: #fff; font-weight: bold; padding: 5px 0px;" type="flex" align="middle">
                <el-col :span="2" style="text-align: center;">网格名</el-col>
                <el-col :span="4" style="text-align: center;">周进度</el-col>
                <el-col :span="18">
                    <el-row style="text-align: center; padding: 5px 0px;">
                        今日走访企业
                    </el-row>
                    <el-row style="font-size: 15px; font-weight: 400;">
                        <el-col :span="7">企业名称</el-col>
                        <el-col :span="4">规模</el-col>
                        <el-col :span="4">分类</el-col>
                        <el-col :span="4">年营收</el-col>
                        <el-col :span="5">荣誉</el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>

        <el-row style="background-color: #003B51; color: #fff; padding-top: 80px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;">第一网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;">计划25家， 进度35%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_1" :key="index" style="padding: 7px 0px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row style="background-color: #0A2732; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;">第二网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;">计划27家， 进度38%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_2" :key="index" style="padding: 7px 0px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>

        <el-row style="background-color: #003B51; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">第三网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划21家， 进度40%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_1" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row style="background-color: #0A2732; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">第四网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划30家， 进度20%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_2" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>

        <el-row style="background-color: #003B51; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">第五网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划31家， 进度33%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_1" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row style="background-color: #0A2732; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">第六网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划35家， 进度40%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_2" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>

        <el-row style="background-color: #003B51; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">第七网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划21家， 进度30%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_1" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row style="background-color: #0A2732; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">第八网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划31家， 进度41%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_2" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>

        <el-row style="background-color: #003B51; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">第九网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划19家， 进度40%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_1" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row style="background-color: #0A2732; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">第十网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划28家， 进度40%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_2" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>

        <el-row style="background-color: #003B51; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">第十一网格</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划25家， 进度37%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_1" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row style="background-color: #0A2732; color: #fff; padding: 10px 0px;" type="flex" align="middle">
            <el-col :span="2" style="text-align: center; font-size: 18px;"">企业服务部</el-col>
            <el-col :span="4" style="text-align: center; font-size: 18px;"">计划30家， 进度30%</el-col>
            <el-col :span="18">
                <el-row v-for="(item, index) in list_wangge_2" :key="index" style="padding: 5px;">
                    <el-col :span="7">{{ item.企业名称 }}</el-col>
                    <el-col :span="4">{{ item.规模 }}</el-col>
                    <el-col :span="4">{{ item.分类 }}</el-col>
                    <el-col :span="4">{{ item.年营收 }}</el-col>
                    <el-col :span="5">{{ item.荣誉 }}</el-col>
                </el-row>
            </el-col>
        </el-row>

    </div>
</template>
<script>
export default {
    data() {
        return {
            list_wangge_1:[
                {
                    "企业名称": "山东宏图建筑有限公司",
                    "规模": "大型企业",
                    "分类": "建筑施工",
                    "年营收": "8亿元",
                    "荣誉": "2023年度鲁班奖"
                },
                {
                    "企业名称": "济南智创科技有限公司",
                    "规模": "中型企业",
                    "分类": "人工智能研发",
                    "年营收": "1.5亿元",
                    "荣誉": "2024年度科技创新企业"
                },
                {
                    "企业名称": "济南智创科技有限公司",
                    "规模": "中型企业",
                    "分类": "人工智能研发",
                    "年营收": "1.5亿元",
                    "荣誉": "2024年度科技创新企业"
                },
            ],
            list_wangge_2:[
                {
                    "企业名称": "济南智创科技有限公司",
                    "规模": "中型企业",
                    "分类": "人工智能研发",
                    "年营收": "1.5亿元",
                    "荣誉": "2024年度科技创新企业"
                },
                {
                    "企业名称": "山东新绿环保科技有限公司",
                    "规模": "中型企业",
                    "分类": "环保技术",
                    "年营收": "2亿元",
                    "荣誉": "2023年度环保先锋企业"
                },
                {
                    "企业名称": "济南星辰文化传媒有限公司",
                    "规模": "小型企业",
                    "分类": "广告传媒",
                    "年营收": "5000万元",
                    "荣誉": "2024年度影响力传媒公司"
                },
            ]
        }
    },
    mounted() {
        // 设置定时器每隔一定时间滚动一次
        setInterval(() => {
            // 向上滚动50px
            window.scrollBy(0, 20)

            let scrollY = window.scrollY
            let windowHeight = window.innerHeight
            let documentHeight = document.body.scrollHeight
            console.log('scrollY',scrollY, 'windowHeight',windowHeight, 'documentHeight',documentHeight)
            if (scrollY + windowHeight >= documentHeight) {
                console.log('已经滚动到底部，重新处理……')
                window.scrollBy(0, -documentHeight);
            }
        }, 1500); // 100毫秒滚动一次
    },
    beforeDestroy() {
        // 清除定时器
        if (this.intervalId) {
            clearInterval(this.intervalId)
        }
    },
}
</script>
<style scoped>
.worklist {
    margin: 0;
    width: 100%;
    height: auto;
    background-color: #02162A;
}
</style>